import React, { useState, useContext } from 'react'
import MachineForm from '../Modals/MachineForm'
import { Redirect } from 'react-router'
import { LangContext } from '../../context/lang-context'
export default ({ machineData, getMachine, deleteMachine }) => {
  const [machineForm, setMachineForm] = useState(null)
  const openMachineForm = () => setMachineForm(true)
  const closeMachineForm = () => setMachineForm(null)
  const { TRL_Pack } = useContext(LangContext)
  return (
    <>
      <div className="card h-100">
        <h5 className="card-header">
          Informacja o automacie
          <button className="float-right btn btn-link link-icon" onClick={() => deleteMachine(machineData.MachineId) && <Redirect to="/dashboard/machines" />}>
            <i className="fas fa-trash text-danger ml-2 mr-2" />
            <span style={{ color: "red" }}>Usuń automat</span>
          </button>
          <button
            className="float-right btn btn-sm btn-link text-decoration-none"
            onClick={openMachineForm}
          >
            <i className="fas fa-pencil-alt mr-2" />
            Edytuj automat

          </button>

        </h5>
        <div className="card-body d-flex flex-column justify-content-center">
          <div className="row mb-3">
            <div className="col-lg-4 mb-2 mb-lg-0 text-lg-right font-weight-bolder">
              Nazwa 
            </div>
            <div className="col-lg-8 my-auto text-center text-lg-left">
              {machineData.Name}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-lg-4 mb-2 mb-lg-0 text-lg-right font-weight-bolder">
              Model
            </div>
            <div className="col-lg-8 my-auto text-center text-lg-left">
              {machineData.Type}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-lg-4 mb-2 mb-lg-0 text-lg-right font-weight-bolder">
              {TRL_Pack.fullMachine.serialNumber}
            </div>
            <div className="col-lg-8 my-auto text-center text-lg-left">
              {machineData.SerialNo}
            </div>
          </div>
          {machineData?.TerminalSerialNo && (
            <div className="row mb-3">
              <div className="col-lg-4 mb-2 mb-lg-0 text-lg-right font-weight-bolder">
                Terminal
              </div>
              <div className="col-lg-8 my-auto text-center text-lg-left">
                {`${(machineData.TerminalTypeId == 1) && "Vendotek" 
                            ||(machineData.TerminalTypeId == 2) && "PAX"
                            ||(machineData.TerminalTypeId == 3) && "NAYAX"
                            ||(machineData.TerminalTypeId == 4) && "Newland"
                            ||(machineData.TerminalTypeId == 5) && "NEXGO"
                            || "nie ma terminali"} (${machineData.TerminalSerialNo})`
                }
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-lg-4 mb-2 mb-lg-0 text-lg-right font-weight-bolder">
              {TRL_Pack.fullMachine.client}
            </div>
            <div className="col-lg-8 my-auto text-center text-lg-left">
              {machineData.CustomerName}
            </div>
          </div>
        </div>
      </div>
      {machineForm && (
        <MachineForm
          postSubmit={getMachine}
          machineData={machineData}
          handleClose={closeMachineForm}
        />
      )}
    </>
  )
}
